import { Box, FormControl, ListItemText, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, Snackbar, Alert, IconButton, TextField, Chip } from '@mui/material';
import React, { Component } from 'react'
import { GridTable } from '../Sidebar/SidebarStyles';
import { GridColDef } from '@mui/x-data-grid';
import { fetchComplianceData, saveComplianceScreenData, getbroker } from '../ApiSevices/UserMasterApis';
import { fetchRole } from '../ApiSevices/RoleMasterApis';
import EditIcon from "@mui/icons-material/Edit";

interface IProps {
    displaysidebar: boolean;
}

interface IState {
    allowedMenus: any[];
    loading: boolean;
    ComplianceTypeData: any[];
    roleOption: any[];
    brokernameOption: any[];
    selectedRow: any;
    isModalOpen: boolean;
    roleDropdownOpen: boolean;
    brokerDropdownOpen: boolean;
    snackbarOpen: boolean;
    snackbarMessage: string;
    snackbarSeverity: 'success' | 'error' | 'info' | 'warning';
}

const columns: GridColDef[] = [
    { field: 'compliancetype', headerName: 'ComplianceType', width: 200 },
    { field: 'role', headerName: 'Role', width: 190 },
    { field: 'broker', headerName: 'BrokerName', width: 190 },
    { field: 'user', headerName: 'User', width: 190 }
];

export default class ComplianceScreen extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            allowedMenus: [],
            loading: false,
            ComplianceTypeData: [],
            roleOption: [],
            brokernameOption: [],
            selectedRow: null,
            isModalOpen: false,
            roleDropdownOpen: false,
            brokerDropdownOpen: false,
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'success',
        }
    }

    async componentDidMount(): Promise<void> {
        try {
            const getComplianceData = await fetchComplianceData();
            if (getComplianceData) {
                this.setState({
                    allowedMenus: getComplianceData,
                });

                await this.getAllData(getComplianceData);
            } else {
                await this.getAllData([]);
            }
        } catch (error) {
            console.error("Error fetching compliance data:", error);
        }
    }

    async getAllData(allowedMenus: any[] = []) {
        try {
            this.setState({ loading: true });
            const Roles = await fetchRole();
            const Brokers = await getbroker();
            const roleOptions = Roles?.map((e: any) => ({ label: e?.RoleName, value: e?.RoleId }));
            const brokerNameOptions = Brokers?.filter((f: any) => f.Broker_ID !== 0)?.map((e: any) => ({ label: e?.vchBrokerName, value: e?.Broker_ID }));
            const constructedMenuAry = allowedMenus?.map((row: any) => ({
                ...row,

                compliancetype: row?.Menu,
                role: row?.RoleId
                    ? row.RoleId.split(',').map((id: string) => parseInt(id.trim(), 10))
                    : [],
                user: row?.UserId
                    ? row.UserId.split(',').map((u: string) => u.trim())
                    : [],
                broker: row?.Broker
                    ? Array.from(new Set(
                        row.Broker
                            .split(',')
                            .map((b: string) => b.trim())
                            .filter(Boolean)
                    ))
                    : []
            }));
            this.setState({
                ComplianceTypeData: constructedMenuAry,
                roleOption: roleOptions,
                brokernameOption: brokerNameOptions
            });
        } catch (error) {
            console.log(error);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    handleChange = (event: any, row: any, column: string) => {
        const value = event.target.value;
        this.setState((prevState) => ({
            ComplianceTypeData: prevState.ComplianceTypeData?.map(e => {
                if (e.Id === row.Id) {
                    return { ...e, [column]: value }
                }
                return { ...e };
            })
        }));
    };

    async updateRoleForUser(): Promise<void> {
        const { ComplianceTypeData } = this.state;
        const selectedData = ComplianceTypeData
            ?.filter(item => item?.isSelected)
            ?.map(item => ({
                menu: item.Menu,
                role_ids: item.role,
                user_ids: item.user,
                broker_ids: Array.from(new Set(
                    (item.broker || []).map((id: any) => String(id))
                ))
            }));

        try {
            this.setState({ loading: true });
            const saveRes = await saveComplianceScreenData(selectedData);
            if (saveRes && selectedData) {
                selectedData?.forEach((res: any) => {
                    const matchedItem = ComplianceTypeData?.find(item => item?.Menu === res?.menu);
                    if (matchedItem) {
                        matchedItem.role = res.role_ids;
                        matchedItem.user = res.user_ids;
                        matchedItem.broker = res.broker_ids;
                        matchedItem.RoleId = res.role_ids?.join(',');
                        matchedItem.UserId = res.user_ids?.join(',');
                        matchedItem.Broker = res.broker_ids?.join(',');
                    }
                });
                this.showSnackbar('Role assigned successfully!', 'success');
            }
        } catch (error) {
            console.error("Error while saving role menu control", error);
        } finally {
            this.setState({ loading: false });
        }
    };

    showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    render() {
        const { loading, ComplianceTypeData, roleOption, brokernameOption, selectedRow, isModalOpen, snackbarOpen, snackbarMessage, snackbarSeverity, } = this.state;
        return (
            <>
                <div
                    style={{
                        fontSize: "12px",
                        backgroundColor: "#f8fafc",
                        minHeight: "100vh",
                        padding: "20px",
                        boxSizing: "border-box",
                    }}
                >
                    {loading && (
                        <Box sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            zIndex: 9999
                        }}>
                            <div className="loader"></div>
                        </Box>
                    )}
                    {/* sx={{ height: '60vh' }} */}
                    <GridTable displaysidebar={this?.props?.displaysidebar}>
                        <div
                            style={{
                                fontSize: "18px",
                                fontWeight: 700,
                                color: "#0f172a",
                                marginBottom: "18px",
                            }}
                        >
                            Compliance Screen Control
                        </div>
                        <div style={{ paddingTop: "10px", paddingRight: "5px" }}>
                            <Paper
                                sx={{
                                    width: '100%',
                                    mb: 2,
                                    overflow: 'hidden',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '12px',
                                    backgroundColor: '#ffffff',
                                    boxShadow: '0 4px 18px rgba(15, 23, 42, 0.08)',
                                }}
                            >
                                <Box sx={{ maxHeight: 450, overflowX: 'auto' }}>
                                    <TableContainer sx={{ minWidth: 'max-content' }}>
                                        <Table stickyHeader sx={{ height: '50px' }} size="small">
                                            {/* Table Header */}
                                            <TableHead>
                                                <TableRow>
                                                    {columns?.map((column) => (
                                                        <TableCell
                                                            key={column.field}
                                                            sx={{
                                                                fontSize: '12px',
                                                                fontWeight: 'bold',
                                                                whiteSpace: 'nowrap',
                                                                backgroundColor: '#f5f5f5',
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 1,
                                                                textAlign: 'center',
                                                                width: column.width
                                                            }}
                                                        >
                                                            {column.headerName}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell
                                                        sx={{
                                                            fontSize: '12px',
                                                            fontWeight: 700,
                                                            whiteSpace: 'nowrap',
                                                            backgroundColor: '#f8fafc',
                                                            color: '#1e293b',
                                                            borderBottom: '1px solid #e2e8f0',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1,
                                                            textAlign: 'center',
                                                            width: '200px',
                                                            height: '52px',
                                                            letterSpacing: '0.2px',
                                                        }}
                                                    >
                                                        Actions
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>

                                        <Box sx={{ maxHeight: 400, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                            <Table size="small">
                                                {/* Table Body */}
                                                <TableBody>
                                                    {ComplianceTypeData && Array?.isArray(ComplianceTypeData) && ComplianceTypeData?.length > 0 ? (
                                                        ComplianceTypeData?.map((row) => (
                                                            <TableRow
                                                                key={row.Id}
                                                                sx={{
                                                                    transition: 'background-color 0.2s ease',
                                                                    '&:hover': {
                                                                        backgroundColor: '#f8fafc',
                                                                    },
                                                                    '&:last-child td': {
                                                                        borderBottom: 'none',
                                                                    },
                                                                }}
                                                            >
                                                                {columns?.map((column) => (
                                                                    <TableCell
                                                                        key={column.field}
                                                                        sx={{
                                                                            fontSize: '10px',
                                                                            color: '#334155',
                                                                            whiteSpace: 'normal !important',
                                                                            wordWrap: 'break-word',
                                                                            lineHeight: '1.5',
                                                                            textAlign: 'center',
                                                                            width: column.width,
                                                                            padding: '13px 10px',
                                                                            borderBottom: '1px solid #eef2f7',
                                                                        }}
                                                                    >
                                                                        {
                                                                            column.field === 'compliancetype' && (
                                                                                <Chip
                                                                                    label={row[column.field]}
                                                                                    size="small"
                                                                                    sx={{
                                                                                        fontSize: '10px',
                                                                                        fontWeight: 600,
                                                                                        borderRadius: '20px',
                                                                                        height: '30px',
                                                                                        paddingLeft: '7px',
                                                                                        paddingRight: '7px',
                                                                                        letterSpacing: '0.1px',

                                                                                        transition: 'all 0.2s ease',

                                                                                        '&:hover': {
                                                                                            transform: 'translateY(-1px)',
                                                                                        },

                                                                                        ...(row[column.field] === 'Commercial Line' && {
                                                                                            backgroundColor: '#E8F1FD',
                                                                                            color: '#1976D2',
                                                                                            border: '1px solid #CFE2FA',
                                                                                            boxShadow: '0 3px 10px rgba(25, 118, 210, 0.18)',

                                                                                            '&:hover': {
                                                                                                backgroundColor: '#DDEBFB',
                                                                                                boxShadow: '0 5px 14px rgba(25, 118, 210, 0.25)',
                                                                                            },
                                                                                        }),

                                                                                        ...(row[column.field] === 'Endorsement Checking' && {
                                                                                            backgroundColor: '#F0E8FA',
                                                                                            color: '#7E57C2',
                                                                                            border: '1px solid #E0D2F3',
                                                                                            boxShadow: '0 3px 10px rgba(126, 87, 194, 0.18)',

                                                                                            '&:hover': {
                                                                                                backgroundColor: '#E9DDF7',
                                                                                                boxShadow: '0 5px 14px rgba(126, 87, 194, 0.25)',
                                                                                            },
                                                                                        }),

                                                                                        ...(row[column.field] === 'Personal Line' && {
                                                                                            backgroundColor: '#E7F5ED',
                                                                                            color: '#2E8B57',
                                                                                            border: '1px solid #D0EBDD',
                                                                                            boxShadow: '0 3px 10px rgba(46, 139, 87, 0.18)',

                                                                                            '&:hover': {
                                                                                                backgroundColor: '#DDF0E5',
                                                                                                boxShadow: '0 5px 14px rgba(46, 139, 87, 0.25)',
                                                                                            },
                                                                                        }),
                                                                                    }}
                                                                                />
                                                                            )
                                                                        }
                                                                        {
                                                                            column.field === 'broker' && (
                                                                                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                                    {row[column.field]
                                                                                        ?.filter((e: any) => e) // remove empty/null
                                                                                        ?.map((e: any) => brokernameOption?.find((option: any) => option?.value === Number(e))?.label)
                                                                                        ?.filter((label: string | undefined) => !!label)
                                                                                        ?.join(", ")
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }
                                                                        {
                                                                            column.field === 'role' && (
                                                                                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                                    {row[column.field]
                                                                                        ?.filter((e: any) => e) // remove empty/null
                                                                                        ?.map((e: any) => roleOption?.find(option => option?.value === e)?.label)
                                                                                        ?.filter((label: string | undefined) => !!label)
                                                                                        ?.join(", ")
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }
                                                                        {
                                                                            column.field === 'user' && (
                                                                                <div
                                                                                    style={{
                                                                                        whiteSpace: "normal",
                                                                                        wordBreak: "break-word",
                                                                                        overflowWrap: "break-word",
                                                                                        textAlign: "center",
                                                                                        fontSize: "11px",
                                                                                    }}
                                                                                >
                                                                                    {row[column.field]?.join(", ")}
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </TableCell>
                                                                ))}
                                                                <TableCell sx={{ textAlign: "center", width: '200px' }}>
                                                                    <IconButton
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                selectedRow: { ...row, isSelected: true },
                                                                                isModalOpen: true
                                                                            });
                                                                        }}
                                                                        size="small"
                                                                        sx={{
                                                                            color: '#64748b',
                                                                            width: '34px',
                                                                            height: '34px',
                                                                            borderRadius: '8px',
                                                                            transition: 'all 0.2s ease',

                                                                            '&:hover': {
                                                                                color: '#1976d2',
                                                                                backgroundColor: '#E8F1FD',
                                                                                boxShadow: '0 3px 8px rgba(25, 118, 210, 0.15)',
                                                                                transform: 'translateY(-1px)',
                                                                            },
                                                                        }}
                                                                    >
                                                                        <EditIcon fontSize="small" />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (<TableRow>
                                                        <TableCell colSpan={columns.length + 1} align="center" sx={{
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                            color: 'gray',
                                                            padding: '20px',
                                                            borderBottom: 'none',
                                                        }}>
                                                            No records to display
                                                        </TableCell>
                                                    </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </TableContainer>
                                </Box>
                            </Paper>
                        </div>
                    </GridTable>

                    {/* MenuControlModal */}
                    <Modal
                        open={isModalOpen}
                        onClose={() => this.setState({ isModalOpen: false })}
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: 'background.paper',
                            p: 3,
                            borderRadius: 2,
                            boxShadow: 24,
                            width: 400
                        }}>
                            <p><b>Assign Access:</b> {selectedRow?.Menu}</p><br />
                            {/* Role Dropdown */}
                            <span style={{ fontSize: "15px" }}>Select Roles:</span>
                            <FormControl size="small" sx={{ mb: 2, pt: 1, width: 350 }}>
                                <Select
                                    multiple
                                    size="small"
                                    open={this.state.roleDropdownOpen}
                                    onClose={() => this.setState({ roleDropdownOpen: false })}
                                    onOpen={() => this.setState({ roleDropdownOpen: true })}
                                    value={selectedRow?.role || []}
                                    onChange={(event) => {
                                        const updated = { ...selectedRow, role: event.target.value };
                                        this.setState({
                                            selectedRow: updated,
                                            roleDropdownOpen: false,
                                        });
                                    }}
                                    renderValue={(selected) => (
                                        <div
                                            style={{
                                                height: "50px",
                                                overflowY: "auto",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {selected
                                                .map((e: any) => roleOption.find((option) => option.value === e)?.label)
                                                .filter(Boolean)
                                                .join(", ")}
                                        </div>
                                    )}
                                    sx={{
                                        fontSize: "0.8rem",
                                        "& .MuiSelect-select": {
                                            py: 0.5,
                                            px: 1,
                                            height: "50px",
                                            display: "flex",
                                            alignItems: "flex-start",
                                            flexDirection: "column",
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                maxHeight: 250,
                                                width: 200,
                                            },
                                        },
                                    }}
                                >
                                    {roleOption?.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            value={option.value}
                                            sx={{
                                                fontSize: "0.8rem",
                                                minHeight: "28px",
                                                "&.Mui-selected": { backgroundColor: "#80808059" },
                                                "&.Mui-selected:hover": { backgroundColor: "#6e6e6e59" },
                                            }}
                                        >
                                            <ListItemText primary={option.label} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <span style={{ fontSize: "15px" }}>Select BrokerName:</span>
                            <FormControl size="small" sx={{ mb: 2, pt: 1, width: 350 }}>
                                <Select
                                    multiple
                                    size="small"
                                    open={this.state.brokerDropdownOpen}
                                    onClose={() => this.setState({ brokerDropdownOpen: false })}
                                    onOpen={() => this.setState({ brokerDropdownOpen: true })}
                                    value={selectedRow?.broker || []}
                                    onChange={(event) => {
                                        const values = Array.isArray(event.target.value)
                                            ? event.target.value.map((value: any) => String(value))
                                            : [];

                                        const updated = {
                                            ...selectedRow,
                                            broker: Array.from(new Set(values))
                                        };

                                        this.setState({
                                            selectedRow: updated,
                                            brokerDropdownOpen: false,
                                        });
                                    }}
                                    renderValue={(selected) => (
                                        <div
                                            style={{
                                                height: "50px",
                                                overflowY: "auto",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {selected
                                                .map((e: any) =>
                                                    brokernameOption.find(
                                                        option => String(option.value) === String(e)
                                                    )?.label
                                                )
                                                .filter(Boolean)
                                                .join(", ")}
                                        </div>
                                    )}
                                    sx={{
                                        fontSize: "0.8rem",
                                        "& .MuiSelect-select": {
                                            py: 0.5,
                                            px: 1,
                                            height: "50px",
                                            display: "flex",
                                            alignItems: "flex-start",
                                            flexDirection: "column",
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                maxHeight: 250,
                                                width: 200,
                                            },
                                        },
                                    }}
                                >
                                    {brokernameOption?.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            value={String(option.value)}
                                            sx={{
                                                fontSize: "0.8rem",
                                                minHeight: "28px",
                                                "&.Mui-selected": { backgroundColor: "#80808059" },
                                                "&.Mui-selected:hover": { backgroundColor: "#6e6e6e59" },
                                            }}
                                        >
                                            <ListItemText primary={option.label} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* User Dropdown */}
                            <span style={{ fontSize: "15px" }}>Enter User Mails:</span>
                            <FormControl size="small" sx={{ mb: 2, width: 350 }}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    multiline
                                    minRows={4}
                                    placeholder="Enter emails with comma separation"
                                    value={selectedRow?.UserId || ''}
                                    onChange={(event) => {
                                        const newValue = event.target.value.split(',').map(v => v.trim()).filter(v => v);
                                        const updated = { ...selectedRow, user: newValue, UserId: (event?.target?.value || "") };
                                        this.setState({ selectedRow: updated });
                                    }}
                                    sx={{
                                        width: 350,
                                        mb: 2,
                                        fontSize: '12px',
                                        '& .MuiOutlinedInput-input': {
                                            fontSize: '12px',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline legend': {
                                            fontSize: '12px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#ccc',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#1976d2',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#1976d2',
                                            },
                                        },
                                        '& textarea::placeholder': {
                                            color: '#999',
                                            fontStyle: 'italic',
                                            opacity: 1,
                                            fontSize: '12px'
                                        }
                                    }}
                                />
                            </FormControl>

                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                                <button
                                    onClick={() => this.setState({ isModalOpen: false })}
                                    style={{ padding: "5px 15px" }}
                                >
                                    Cancel
                                </button>
                                <button
                                    style={{ padding: "5px 15px", backgroundColor: "#1976d2", color: "#fff", border: "none", borderRadius: "4px" }}
                                    onClick={async () => {
                                        this.setState(
                                            (prevState: any) => ({
                                                ComplianceTypeData: prevState.ComplianceTypeData.map((r: any) =>
                                                    r.Id === this.state.selectedRow.Id ? this.state.selectedRow : r
                                                ),
                                                isModalOpen: false,
                                            }),
                                            async () => {
                                                await this.updateRoleForUser();
                                            }
                                        );
                                    }}
                                >
                                    Save
                                </button>
                            </Box>
                        </Box>
                    </Modal>
                </div>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleCloseSnackbar}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert severity={snackbarSeverity} onClose={this.handleCloseSnackbar}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </>
        )
    }
}
